import { GetterTree } from "vuex";
import { ICreditLimitManagementState } from "@/core/interfaces/state/creditLimitManagementState.interface";
import { IPaginatedCreditLimitRequests } from "@/core/interfaces/state/creditLimitRequest.interface";
import {
  ICreditLimitRequestDetail,
  ICreditLimitSlab,
} from "@/core/interfaces/state/creditLimitRequestDetail.interface";
import { StoreState } from "@/store/type";

const getters: GetterTree<ICreditLimitManagementState, StoreState> = {
  isFetchingCreditLimitRequests: (
    state: ICreditLimitManagementState,
  ): boolean => state.isFetchingCreditLimitRequests,
  isFetchingCreditLimitRequestDetail: (
    state: ICreditLimitManagementState,
  ): boolean => state.isFetchingCreditLimitRequestDetail,
  isCreatingCreditLimitRequest: (state: ICreditLimitManagementState): boolean =>
    state.isCreatingCreditLimitRequest,
  isProcessingCreditLimitRequest: (
    state: ICreditLimitManagementState,
  ): boolean => state.isProcessingCreditLimitRequest,
  creditLimitRequests: (
    state: ICreditLimitManagementState,
  ): IPaginatedCreditLimitRequests => state.creditLimitRequests,
  creditLimitRequestDetail: (
    state: ICreditLimitManagementState,
  ): ICreditLimitRequestDetail | null => state.creditLimitRequestDetail,
  creditLimitSlabs: (state: ICreditLimitManagementState): ICreditLimitSlab[] =>
    state.creditLimitSlabs,
  creditLimitSlabsLoading: (state: ICreditLimitManagementState): boolean =>
    state.isCreditLimitSlabLoading,
};

export default getters;
